import { render, staticRenderFns } from "./MenuDocente.vue?vue&type=template&id=296dce04&"
import script from "./MenuDocente.vue?vue&type=script&lang=js&"
export * from "./MenuDocente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports